var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1195_7390)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1195_7390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.772461 3.8147e-06H48.7725V48H0.772461V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1195_7390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16653 2.01557L19.6138 12.4629C18.2577 13.8177 16.1613 15.9103 14.4209 17.6414C13.4159 18.6409 13.3212 20.2164 14.1741 21.3485C15.9722 23.7358 18.6196 26.9075 20.9102 29.1981C22.8638 31.1517 25.3755 32.985 27.6528 34.5988C28.7532 35.3785 30.2696 35.2 31.2206 34.2438C32.8219 32.6339 34.7417 30.7093 36.3566 29.0926L46.8038 39.5398C46.8038 39.5398 45.4173 40.9262 41.7649 44.5787C37.9707 48.3729 30.9953 46.414 24.1308 41.807C11.4486 33.2959 -2.95356 14.1357 4.05378 7.12832L9.16653 2.01557Z",
    stroke: "#0686D8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.085 4.21875C37.6144 4.21875 44.5537 11.158 44.5537 19.6875",
    stroke: "#0686D8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.085 9.84375C34.5122 9.84375 38.9287 14.2602 38.9287 19.6875",
    stroke: "#0686D8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.085 15.4688C31.4149 15.4688 33.3037 17.3575 33.3037 19.6875",
    stroke: "#0686D8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1195_7390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.772461)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.2e3a86b9aacfce505011662a36810c9b.svg";
export { ForwardRef as ReactComponent };